The personal details of the candidate to be uploaded.

At least one email address is required in `communication`,
and one of the provided values must match `seekPrimaryEmailAddress`.
